<template>
  <div v-if="itemid">
    <h3 style="margin-top: 30px">Bank Verification Completed</h3>
    <p>
      Congrats! You verified your account. We are now getting your offers ready.
    </p>
    <div class="buttons is-right">
      <!-- <a class="button is-link  next-button is-loading" @click="next">Continue</a> -->
      <a
        class="button is-link padded-button next-button is-loading"
        @click="next"
        >Continue</a
      >
    </div>
  </div>
  <div v-else>
    <div id="main_container">
      <div style="" id="image_title_container">
        <img
          src="https://cardiff.b-cdn.net/img/ops_title.svg"
          id="logo"
          height="180"
          width="352"
          style="display: block"
        />
        <img
          src="https://cardiff.b-cdn.net/img/bank_icon.png"
          class="bank_icon"
          height="248"
          width="248"
          style="display: block"
        />
        <div class="buttons button_container">
          <a
            class="button is-link next-button pure-button btn-success"
            @click="back"
            id="continue-journey-lead-bank-verification"
            >CONNECT WITH PLAID</a
          >
        </div>
        <h3 id="advantages_title">
          Advantages of connecting with Plaid<sup>TM</sup>
        </h3>
        <p class="advantages_item">
          Applicants who connect with Plaid can be approved and funded same day
        </p>
        <div class="advantage_separator"></div>
        <p class="advantages_item">
          Receive an offer up to 30% more<sup>1</sup> when connected with Plaid
        </p>
        <div class="advantage_separator"></div>
        <p class="advantages_item">
          Choose a daily, weekly, or monthly payment schedule when connected
          with Plaid<sup>2</sup>
        </p>
        <h3 id="lets_try">Now, let’s try this again:</h3>
        <div class="buttons button_container">
          <a
            class="button is-link next-button pure-button btn-success"
            @click="back"
            id="continue-journey-lead-bank-verification"
            >CONNECT WITH PLAID</a
          >
        </div>
        <div v-if="this.device_type == 'desktop'">
          <p>Or you can:</p>
          <div id="filebox" :class="ready ? 'faded' : ''">
            <p v-if="fileList.length < 1">
              Upload up to 12 months of bank statements
            </p>
            <p v-else>+ Add More Files</p>
            <input type="file" name="file" id="file-input" multiple />
          </div>
          <!-- <hr class="ccc" /> -->
          <div
            class="advantage_separator"
            style="margin-top: 30px; margin-bottom: 30px"
          ></div>
          <div class="buttons" id="done_adding_files_container">
            <!-- <a class="button  next-button" @click="back">Try Again</a> -->
            <a
              id="done_adding_files"
              class="button is-link next-button pure-button"
              style="opacity: 0.75; background-color: #21428e"
              @click="ready = true"
              v-if="!ready && fileList.length > 0"
              >Done Adding Files?</a
            >
            <a
              class="button is-link next-button"
              @click="uploadFiles"
              v-if="ready"
              >Upload Now</a
            >
          </div>
          <div
            v-for="(entry, idx) in fileList"
            class="file-entry"
            :key="'file' + idx"
          >
            <!-- <div class="entry-input">
        <Dropdown
          :inputField="entry.month"
          :options="monthOptions"
          inputName="Statement Month"
          inputType="string"
        />
      </div> -->
            <div class="entry-input">
              <p
                class="is-size-7 is-family-monospace"
                style="font-weight: bold; font-size: 10px; margin-bottom: 5px"
              >
                {{ "Document " + (idx + 1) }}
              </p>
              <p class="file_entry_name" style="">
                {{ entry.file.name }}
              </p>
            </div>
            <div class="entry-info" style="font-size: 12px">
              <p class="is-size-7" style="margin-bottom: 5px">
                {{ humanFileSize(entry.file.size) }}
              </p>
              <p
                class="is-size-7 is-family-monospace"
                style="font-weight: bold; font-size: 10px"
              >
                Ready to upload
              </p>
            </div>
            <hr />
          </div>
        </div>
        <p class="notes">
          *Cardiff can fund same day for applications approved by 5:00 p.m.
          Eastern Time on bank business days.
        </p>
        <p class="notes">
          <sup>1</sup>By connecting with Plaid<sup>TM</sup>, Cardiff will be
          able to evaluate your business banking data in real-time, thereby
          increasing its offer up to 30%.
        </p>
        <p class="notes">
          <sup>2</sup>As a result of successfully connecting with
          Plaid<sup>TM</sup>, Cardiff may be willing to allow the user to choose
          payment remittance cadence.
        </p>
      </div>
      <div id="image_container_desktop">
        <img
          src="https://cardiff.b-cdn.net/img/iphone-statement.png"
          class="iphone_plaid_desktop"
          height="723"
          width="948"
        />
      </div>
    </div>
    <!-- <h3 style="margin-top: 30px">Bank Statement Upload Required</h3>
    <p>
      Unfortunately, we were unable to verify your account electronically using
      Plaid.
    </p>
    <p>
      You can
      <a @click="back">click here to try again</a> or manually upload
      <strong>at least 6 months of business bank</strong>
      statements below.
    </p>
    <h5 style="margin-top: 30px">Upload up to 12 Months of Bank Statements</h5> -->
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import $ from "jquery";
import Dropdown from "@/components/shared/Dropdown";

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

function getDeviceType() {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
}

export default {
  name: "PlaidResult",
  components: {},
  props: {
    itemid: String,
    api: String,
    link: String,
  },
  data() {
    return {
      obj: "financials",
      inputs: {
        ts: "",
      },
      monthOptions: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      attached: false,
      clicked: false,
      ready: false,
      fileList: [],
      device_type: "",
    };
  },
  mounted: function () {
    var self = this;
    this.device_type = getDeviceType();
    // setTimeout()
    if (self.itemid) {
      setTimeout(this.next, 5000);
      setTimeout(function () {
        var ecData = {
          email: getWithExpiry("email"),
          phone_number: getWithExpiry("phone_number"),
          address: {
            first_name: getWithExpiry("first_name"),
            last_name: getWithExpiry("last_name"),
            street: getWithExpiry("street"),
            city: getWithExpiry("city"),
            region: getWithExpiry("state"),
            postal_code: getWithExpiry("postal_code"),
            country: "us",
          },
        };
        let monthly_sales = getWithExpiry("monthly_sales");
        // console.log("monthly_sales: " + monthly_sales);
        // console.log("page: " + self.page);
        let monthly_sales_float = 0;
        if (monthly_sales && monthly_sales != "") {
          monthly_sales_float = parseFloat(monthly_sales.replace(/,/g, ""));
        }
        self.$gtm.trackEvent({
          event: "complete_app",
          ecData: ecData,
          // category: 'Contact Form',
          // action: 'click',
          // label: 'Contact Form Complete',
          value: monthly_sales_float,
        });
        fbq("track", "SubmitApplication");
      }, 2000);
    }
    setTimeout(function () {
      var fileInput = document.getElementById("file-input");
      fileInput.addEventListener("change", function (e) {
        // self.fileList = [];
        for (var i = 0; i < fileInput.files.length; i++) {
          self.fileList.push({
            idx: i,
            file: fileInput.files[i],
            month: Input.model("January"),
          });
        }
        console.log("new filelist", self.fileList);
      });
    }, 2000);
    $("#transition_container").css("max-width", "100%");
  },
  methods: {
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
    back() {
      this.$emit("back", this.$data);
      console.log(this.$data);
    },
    humanFileSize(bytes, si = false, dp = 1) {
      const thresh = si ? 1000 : 1024;

      if (Math.abs(bytes) < thresh) {
        return bytes + " B";
      }

      const units = si
        ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
      let u = -1;
      const r = 10 ** dp;

      do {
        bytes /= thresh;
        ++u;
      } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
      );

      return bytes.toFixed(dp) + " " + units[u];
    },
    uploadFiles() {
      console.log(this.doc);
      console.log(this.link);
      var self = this;
      if (this.clicked) {
        return;
      }
      if (!$("#file-input").val()) {
        alert("Please upload a valid file.");
        return;
      }
      this.clicked = true;
      var fd = new FormData();

      $.each($("input[type='file']")[0].files, function (i, file) {
        fd.append("file", file);
      });

      // fd.append("file", $('#file-input')[0].files[0])
      self.fileList.forEach((f) => {
        fd.append("fileinfo", JSON.stringify(f));
      });

      fd.append("link", self.link);
      $.ajax({
        type: "POST",
        url: "/api/" + self.api + "/upload-statements",
        contentType: false,
        processData: false,
        data: fd,
      })
        .done(function (resp) {
          self.next();
        })
        .fail(function (err) {
          self.clicked = false;
        });
      console.log(fd);
      //upload the file here
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ccc {
  background-color: #ccc;
}
#file-input {
  height: 100%;
  width: 100%;
  background-color: #dbe9ff;
  opacity: 0;
  /* padding: 10px; */
  position: absolute;
  top: 0px;
  left: 0px;
  cursor: pointer;
}
.file_entry_name {
  margin-bottom: 0px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
#filebox {
  line-height: 3;
  /* align-items: center; */
  /* text-align: center; */
  border-radius: 5px;
  /* background: #3273dccc; */
  /* color: white; */
  /* font-variant: all-small-caps; */
  /* margin-bottom: 20px; */
  position: relative;
  transition: all 0.5s;
  cursor: pointer;
  /* font-size: 24px; */
  /* changes */
  font-size: 16px;
  height: 40px;
  color: #3a67d2;
  text-decoration: underline;
}
#filebox:hover {
  /* background: #3273dca3; */
  cursor: pointer;
}
#filecounter {
  font-weight: bold;
  text-align: center;
  font-variant-caps: all-petite-caps;
  background: #fcfdff;
  padding: 5px;
}
.file-entry {
  padding: 8px;
  background: #e6eefb87;
  border-radius: 5px;
  margin-bottom: 10px;
  display: flex;
  align-content: center;
  align-items: center;
  border: 2px solid #5972aa;
}
.entry-info {
  text-align: right;
  padding: 5px;
}
.entry-input {
  flex-grow: 1;
  flex-basis: "auto";
}
.faded {
  opacity: 0.3;
}
/* start new design */
#success_container {
  margin-top: 64px !important;
  height: 70vh;
}
sup {
  font-size: 50%;
}
#advantages_title {
  font-size: 36px;
  font-weight: bold;
  font: normal normal bold 32px/30px Roboto;
  letter-spacing: 0px;
  color: #000000;
  text-align: left;
}
.advantages_item {
  font: normal normal normal 20px/24px Roboto;
  letter-spacing: 0px;
  color: #000000;
  text-align: left;
  /* margin-left: 5%;
  margin-right: 5%; */
}
.advantage_separator {
  border-top: 1px solid #ccc;
  padding-bottom: 10px;
  padding-top: 5px;
}

.iphone_plaid_mobile {
  display: none;
}
#shield {
  max-width: 300px;
  margin: auto;
  display: block;
}
#main_container {
  display: flex;
  /* mobile */
  background: url("https://cardiff.b-cdn.net/img/gradient-desktop.png");
  background-repeat: no-repeat;
  /* /* height: 390px; */
}
#image_title_container {
  /* mobile */

  background-size: contain;
  /* max-height: 650px; */
  margin-left: 5%;
  /* background: transparent linear-gradient(52deg, #ffffff 0%, #d4dbec 100%) 0% 0%
    no-repeat padding-box;
  opacity: 1; */
}
#image_container_desktop {
  margin-top: 17px;
}
#logo {
  padding-top: 64px;
  /* margin-bottom: 21px; */
  width: 681px;
  /* height: 397px; */
}
#iphone_plaid {
  margin-bottom: 32px;
}
/* .button_container {
  margin-left: 3%;
} */
.notes {
  text-align: left;
  font: normal normal normal 16px/19px Roboto;
  letter-spacing: 0px;
  color: #666666;
  opacity: 1;
  margin-right: 8%;
}
.pure-button {
  border-radius: 24px;
  /* border: 2px solid transparent; */
  font-family: Roboto;
  font-size: 16px;
  /* font-weight: 500; */
  font-weight: 900;
  opacity: 1;
  text-align: center;
  font: normal normal 900 16px/40px Roboto;
  letter-spacing: 0.8px;
  color: #ffffff;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 20px;
  letter-spacing: 0.9px;
  /* mobile */
  height: 46px;
  width: 240px;
}
.btn-success {
  background: #28a745 0% 0% no-repeat padding-box;
  color: #ffffff !important;
}
/* #app-column {
  padding-top: 0 !important;
} */
#lets_try {
  font: normal normal bold 32px/24px Roboto;
  letter-spacing: 0px;
  color: #000000;
  margin-bottom: 32px;
}
@media (max-width: 80em) {
}
@media (max-width: 47.999em) {
  .done_adding_files_container {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  #success_container {
    margin-top: 64px !important;
    height: auto;
  }
  #image_title_container {
    text-align: center;
    margin-top: -38px;
    padding-top: 48px;
    padding-top: 80px;

    max-height: none;
    background: url("https://cardiff.b-cdn.net/img/gradient-mobile.png");
    background-repeat: no-repeat;
    margin-left: 0;
    background-size: contain;
  }

  .notes {
    /* margin-left: 32px; */
    margin-left: 8%;
  }
  #main_container {
    display: block;
    padding-top: 14px;
  }
  #image_container_desktop {
    display: none;
  }
  .iphone_plaid_mobile {
    display: block;
    margin: 0 auto;
  }
  #logo {
    width: 90%;
    width: 340px;
    height: 208px;
    padding-top: 0;
    display: unset !important;
  }
  /* #image_title_container {
    display: unset;
  } */
  .bank_icon {
    display: unset !important;
  }
  #advantages_title {
    font-size: 24px;
    margin-left: 8%;
    margin-right: 8%;
  }
  .advantages_item {
    font-size: 16px;
    margin-left: 8%;
    margin-right: 8%;
  }
  .advantage_separator {
    margin-left: 8%;
    margin-right: 8%;
  }
  .pure-button {
    margin: 0 auto;
  }
}
</style>
